import { render, staticRenderFns } from "./home.vue?vue&type=template&id=0882aca0&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=0882aca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0882aca0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0882aca0')) {
      api.createRecord('0882aca0', component.options)
    } else {
      api.reload('0882aca0', component.options)
    }
    module.hot.accept("./home.vue?vue&type=template&id=0882aca0&scoped=true&", function () {
      api.rerender('0882aca0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/usergroup/home.vue"
export default component.exports